import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { userActions, useAppDispatch, useAppSelector, userSelectors, } from '@pomofocus/shared-client';
import LoginForm from './LoginForm';
import { checkIfElectron } from '../common/DeviceCheck';
// import accessTokenUtils from '../../utils/AccessTokenUtils';
import { WebTokenProvider } from '../../utils/webTokenProvider';
const LoginContainer = (props) => {
    const dispatch = useAppDispatch();
    const authenticated = useAppSelector(userSelectors.selectIsAuthenticated);
    const errorMessage = useAppSelector((state) => state.user.signupError);
    const activities = useAppSelector((state) => state.activity.activities);
    const isElectron = checkIfElectron();
    useEffect(() => {
        if (authenticated) {
            props.history.replace('/app');
        }
    }, [authenticated, props.history]);
    const handleClickGoogle = (code, todos) => {
        dispatch(userActions.loginWithGoogle({
            code,
            todos,
            callback: (accessToken) => {
                new WebTokenProvider().saveToken(accessToken);
                dispatch(userActions.fetchUser());
                props.history.push('/app');
            },
        }));
    };
    const submit = (email, password) => {
        dispatch(userActions.displaySignupError({ errorMsg: '' }));
        dispatch(userActions.loginWithEmail({
            email,
            password,
            callback: (accessToken) => {
                new WebTokenProvider().saveToken(accessToken);
                dispatch(userActions.fetchUser());
                props.history.push('/app');
            },
        }));
    };
    const displayErrorMessage = (message) => {
        dispatch(userActions.displaySignupError({ errorMsg: message }));
    };
    const handleClickSwitch = () => {
        dispatch(userActions.displaySignupError({ errorMsg: '' }));
        props.history.push('/signup');
    };
    const handleClickForgotPass = () => {
        props.history.push('/reset-password');
    };
    const loginWithAuthCode = (code) => {
        dispatch(userActions.loginWithAuthCode({
            authCode: code,
            callback: (token) => {
                new WebTokenProvider().saveToken(token);
                dispatch(userActions.fetchUser());
                props.history.push('/app');
            },
        }));
    };
    if (authenticated !== false) {
        return null;
    }
    return (React.createElement(LoginForm, { ...props, errorMessage: errorMessage, isElectron: isElectron, activities: activities, handleClickGoogle: handleClickGoogle, submit: submit, displayErrorMessage: displayErrorMessage, handleClickSwitch: handleClickSwitch, handleClickForgotPass: handleClickForgotPass, loginWithAuthCode: loginWithAuthCode }));
};
export default withRouter(LoginContainer);
